import type { Selector } from '@reduxjs/toolkit';

export type SelectorsMap<State, SelectorName extends string> = Record<SelectorName, Selector<State>>;

export const createSliceSelector =
    <RootState>(sliceName: keyof RootState) =>
    (state: RootState) =>
        state[sliceName];

// export const composeSelectors2 = (s1: Selector<>, s2: Selector) => (state: Parameters<typeof s1>[0], params?: Parameters<typeof s2>[1]): ReturnType<typeof s2> => (s2(s1(state), params) as ReturnType<typeof s2>);

export const globalizeSelector = <RootState>(selector: Selector, name: keyof RootState) => {
    const namedSelector = createSliceSelector<RootState>(name);

    return (state: RootState) =>
        (selector as Selector<RootState[typeof name]>)(namedSelector(state)) as Selector<
            RootState,
            ReturnType<typeof selector>
        >;
};

// export const composeSelectors = <RootState, K extends keyof RootState>(names: K[], selectorsMap: Record<K, Selector>) =>
//     names.reduce((mappedSelectors, name) => {
//         const selector = selectorsMap[name];
//         const namedSelector = createSelectorByName<RootState, typeof name>(name);
//         mappedSelectors[name] = (state: RootState, ...params: any) => selector(namedSelector(state), ...params) as Selector;
//         return mappedSelectors;
// }, {} as Record<K, Selector>)
